import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import eventBus from 'services/eventBus'
import useTableWithRequest from 'shared/Table/useTableWithRequest'
import ProtectionsTableFields from './ProtectionsTable.field'
import protectionsTableAtom from './Protections.atom'
import Table from 'shared/Table'
import useItemsSetter from 'recoil/useItemsSetter'
import protectionsApi from 'screens/Protection/protection.api'
import { useRecoilValue } from 'recoil'
import { IMeRegistrations } from 'screens/Protection/protection.types'

const ProtectionsTable = () => {
  const state = useRecoilValue(protectionsTableAtom)
  const navigate = useNavigate()
  const itemsSetter = useItemsSetter(protectionsTableAtom)

  useEffect(() => {
    const unsub = eventBus.sub('protectionTemplate.updated', ({ id, updates }) => {
      itemsSetter((prevItems) => prevItems.map((item) => (item.id === id ? { ...item, ...updates } : item)))
    })
    return unsub
  }, [itemsSetter])

  const fetcher = useCallback((params: Record<string, any>) => {
    return protectionsApi.getStudentRegistrations(params)
  }, [])

  const tableCtrl = useTableWithRequest({
    dataFetcher: fetcher,
    fields: ProtectionsTableFields,
    itemKey: 'id',
    items: state.items,
    setItems: itemsSetter,
    tableKey: 'protections-student',
  })

  const handleClick = useCallback((val: IMeRegistrations) => {
    navigate(`/protections/${val.defenceId}/team/${val.teamId}`)
  }, [])

  return (
    <Table
      {...tableCtrl}
      items={tableCtrl.orderedItems}
      handleSelect={tableCtrl.selectedCtrl.setSelected}
      selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof IMeRegistrations>}
      handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
      itemKey='id'
      onCLick={handleClick}
      selectEnabled={false}
    />
  )
}

export default ProtectionsTable
